
import { computed, defineComponent, PropType } from 'vue';

import EasyDrop from "@/components/EasyDrop.vue";
import TransferOption from '@/components/Booking/Transfers/TransferOption.vue';
import { SearchBookingOverview } from '@/types/models';
import { LocaleStrings } from '@/types/paramModels';

export default defineComponent({
  components: {
    EasyDrop,
    TransferOption
  },
  props: {
    bookingOverview: {
      type: Object as PropType<SearchBookingOverview>,
      required: true,
    },
    searchQuery: {
      type: Object,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  setup(_props) {

    const searchBookingOverview = computed(() => _props.bookingOverview);
    const selectedTransferKey = computed(() => searchBookingOverview?.value.bookingSelection?.hotelTransferKey as string);
    
    const query = computed(() => _props.searchQuery);

    const obligatoryTransferText = () => {
      return _props.pageTexts['hotelPageTransferStepOnlyOneChoiceMandatory'].replace(/\[[transfer\]]+\]/g, searchBookingOverview.value.transfers[0].name);
    }

    return {
      query,
      searchBookingOverview,
      selectedTransferKey,
      obligatoryTransferText
    }
  },
})
